module.exports = __webpack_public_path__ + "static/media/logo_black.b18dba4d.png";